import { StorageKeys } from "../common/storageKeys";
import { atom, useRecoilState, useRecoilValue } from "recoil";

export enum UserStateKeys {
  Info = "Info",
}

export const initialUserInfoState = {
  expireDate: new Date(),
  fullName: localStorage.getItem(StorageKeys.userName) || "",
  phoneNumber: "",
  sessionId: "",
  token: "",
  tokenType: "",
  order: localStorage.getItem(StorageKeys.order) || 0,
  merchantId: localStorage.getItem(StorageKeys.merchantId) || 0,
  merchantName: localStorage.getItem(StorageKeys.merchantName) || "",
  level: localStorage.getItem(StorageKeys.level) || 0,
  userId: localStorage.getItem(StorageKeys.userId) || 0,
  isPayoutBlocked: localStorage.getItem(StorageKeys.isPayoutBlocked) === "true" || false,
  payoutBlockReason: localStorage.getItem(StorageKeys.payoutBlockReason) || "",
  userType: localStorage.getItem(StorageKeys.userType) || "",
};

const user = atom({
  key: UserStateKeys.Info,
  default: initialUserInfoState,
});

export const useUserInfo = () => useRecoilState(user);
export const useUserInfoValue = () => useRecoilValue(user);
